import { useClientFilterColumns } from 'src/composables/columnDefinitions/clientFilterColumns';

/** Standard client properties a cohort can be defined by, in the order the dialog offers them. */
const COHORT_FILTER_COLUMN_NAMES = [
  'age',
  'reference',
  'gender',
  'postalCode',
  'city',
  'state',
  'country',
  'units',
];

/**
 * Filter vocabulary of the cohort criteria dialog.
 *
 * @returns {{
 *   columns: import('vue').ComputedRef<Array<Object>>,
 *   columnGroups: import('vue').ComputedRef<Array<Object>>,
 * }}
 */
// eslint-disable-next-line import/prefer-default-export
export function useCohortsFiltersColumns() {
  return useClientFilterColumns({ columnNames: COHORT_FILTER_COLUMN_NAMES });
}
